<div class="row">
  <div class="col-md-12 col-sm-12 d-flex justify-content-center align-items-center justify-padding top-exposure-image-container">
    <a class="exposure-picture">
      <img src="'assets/images/No_Image.png'" onerror="this.onerror=null;this.src='assets/images/No_Image.png'" class="exposure-img" width="100%">
    </a>
    <div class="exposure-date">
      <span>-</span>
    </div>
  </div>
  <div class="col-md-12 col-sm-12 d-flex justify-content-center platform-title">
    <div class="d-flex flex-row align-items-center">
      <img src="assets/images/question-mark.png" onerror="this.onerror=null;this.src='assets/images/No_Image.png'" width="21px" height="21px">
      <div><span class="exposure-type-title">{{name}}</span></div>
    </div>
  </div>
  <div class="col-md-12 col-sm-12">
    <div class="d-flex justify-content-center align-items-center">
      <span class="exposure-count">-</span>
    </div>
  </div>
</div>



// WEBPACK FOOTER //
// ./src/app/main/influencer/influencer-insight/top-exposure-placeholder/top-exposure-item-placeholder/top-exposure-item-placeholder.component.html